export const getStatusBadgeClass = (status, type = "campaign") => {
  const MAP = {
    campaign: { active: "bg-green-50 text-green-700 border-green-200", completed: "bg-blue-50 text-blue-700 border-blue-200" },
    email: { sent: "bg-green-50 text-green-700 border-green-200", scheduled: "bg-blue-50 text-blue-700 border-blue-200" },
    social: { published: "bg-green-50 text-green-700 border-green-200", failed: "bg-red-50 text-red-700 border-red-200" },
  };
  const defaults = { campaign: "bg-slate-100 text-slate-700 border-slate-200", email: "bg-slate-100 text-slate-700 border-slate-200", social: "bg-blue-50 text-blue-700 border-blue-200" };
  return MAP[type]?.[status] || defaults[type] || "bg-slate-100 text-slate-700 border-slate-200";
};

export const CHART_TOOLTIP_STYLE = {
  borderRadius: 0,
  border: "1px solid #E2E8F0",
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
};

export const CHART_TICK_SM = { fontSize: 11 };
export const CHART_TICK_XS = { fontSize: 12 };

export const getRoleBadgeLabel = (role) => {
  if (role === "bdm") return "BDM";
  if (role === "bde") return "BDE";
  if (role === "cfo") return "CFO";
  if (role === "marketing_head") return "Mktg Head";
  return role;
};

export const getRankLabel = (idx) => {
  if (idx === 0) return "1st";
  if (idx === 1) return "2nd";
  if (idx === 2) return "3rd";
  return `${idx + 1}th`;
};

export const getRankColor = (idx) => {
  if (idx === 0) return "#F59E0B";
  if (idx === 1) return "#94A3B8";
  if (idx === 2) return "#CD7F32";
  return "#475569";
};

export const getDealProbability = (stage) => {
  const map = { prospect: 20, negotiation: 40, proposal: 70, closed_won: 100, closed_lost: 0 };
  return map[stage] || 20;
};

export const getMeetingStatusClass = (status) => {
  if (status === "completed") return "bg-green-50 text-green-700 border-green-200";
  return "bg-blue-50 text-blue-700 border-blue-200";
};

export const getLeadScoreColor = (temperature) => {
  if (temperature === "hot") return "#DC2626";
  if (temperature === "warm") return "#F59E0B";
  return "#60A5FA";
};
